import type { ProductType } from "shared/products/domain/productType";
import type { LogData } from "./common/logData";
import type { ProductResponse } from "./common/productResponse";
import type { CoilData } from "./common/coilData";
import { useProductStore } from "shared/products/stores/productStore";
import { useCreateEntityApi } from "@/common/api/createEntityApi";
import type { BulkData } from "shared/products/domain/product";

export interface CreateProduct {
  name: string;
  description: string;
  type: ProductType;
  color: string | null;
  externalCode: string | null;
  quality: string | null;
  logData: LogData | null;
  coilData: CoilData | null;
  bulkData: BulkData | null;
  productGroupId: string | null;
}

export interface CreateProductSucessResponse {
  ok: true;
  product: ProductResponse;
}

export function useCreateProduct() {
  const productStore = useProductStore();

  return useCreateEntityApi<CreateProduct, CreateProductSucessResponse>({
    url: 'product',
    translate: (t) => t.products.actions.create,
    async processOk(response) {
        const json = await response.json() as ProductResponse;
        productStore.add(json);
        return {
          ok: true,
          product: json
        };
    }
  });
}


